import { Coins } from "lucide-react";

const money = (v) => Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

function Stat({ label, value, testid, big }) {
  return (
    <div data-testid={testid}>
      <div className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground">{label}</div>
      <div className={`font-mono font-semibold ${big ? "text-2xl text-primary" : "text-base"}`} data-testid={`${testid}-value`}>{value}</div>
    </div>
  );
}

export function WalletTotals({ wallets, usd }) {
  const usdc = wallets.reduce((s, w) => s + (w.usdc_balance || 0), 0);
  const usdt = wallets.reduce((s, w) => s + (w.usdt_balance || 0), 0);
  const once = usd + usdc + usdt;
  const perWallet = usd * wallets.length + usdc + usdt;
  return (
    <div className="rounded-xl border border-border bg-card p-6" data-testid="wallet-totals">
      <div className="mb-4 flex items-center gap-2 text-sm font-medium"><Coins className="h-4 w-4 text-primary" /> Combined value · {wallets.length} wallet{wallets.length === 1 ? "" : "s"}</div>
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-5">
        <Stat big label="Total (USD counted once)" value={`$${money(once)}`} testid="wallet-total-once" />
        <Stat big label="Total (USD per wallet)" value={`$${money(perWallet)}`} testid="wallet-total-per-wallet" />
        <Stat label="USD · card balance" value={`$${money(usd)}`} testid="wallet-total-usd" />
        <Stat label="USDC · vault tracked" value={money(usdc)} testid="wallet-total-usdc" />
        <Stat label="USDT · vault tracked" value={money(usdt)} testid="wallet-total-usdt" />
      </div>
      <p className="mt-3 text-[11px] text-muted-foreground">USDC and USDT are treated as $1 each.</p>
    </div>
  );
}
